export default __webpack_public_path__ + "static/media/6-2.db54c3d1.mp3";